import { todayInRome } from './get-date-worlds-format';

export function fConvertDateFormat(data: string): string {
  if (data) {
    const date = new Date(data);
    const day = `0${date.getDate()}`.slice(-2);
    const month = `0${date.getMonth() + 1}`.slice(-2);
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  }
  return '';
}

/**
 * NAT-2820 — fConvertDateFormat for the export paths: dd-MM-yyyy on the Europe/Rome day, whatever
 * zone the browser is in. A bare yyyy-MM-dd is a calendar day and prints as it is; anything else
 * is an instant and is read on its Rome day. Empty or unparseable input gives ''.
 */
export function fConvertDateFormatRome(data: string): string {
  if (!data) return '';
  const bare = /^(\d{4})-(\d{2})-(\d{2})$/.exec(data);
  if (bare) return `${bare[3]}-${bare[2]}-${bare[1]}`;
  const instant = new Date(data);
  if (Number.isNaN(instant.getTime())) return '';
  const [year, month, day] = todayInRome(instant).split('-');
  return `${day}-${month}-${year}`;
}

export const getMonthDays = (yearParam: number, monthParam: number): number =>
  new Date(yearParam, monthParam, 0).getDate();

export const formatYearMonthDay = (
  yearValue: number | string,
  monthValue: number,
  dayValue: number,
) =>
  `${yearValue}-${monthValue.toString().padStart(2, '0')}-${dayValue.toString().padStart(2, '0')}`;
